export default function dimmBackground() {
  const root = document.getElementById('root')

  if (root) root.classList.add('dimmed')

  return () => {
    if (root) root.classList.remove('dimmed')
  }
}
